import {Box} from "@mui/material";
import skyline from "../images/skyline.svg";
import React from "react";

export function Skyline() {
    return (
        <Box sx={{
            width: 1,
            height: {xl: '150px', lg: '120px', md: '100px', xs: '100px'},
            backgroundImage: `url(${skyline})`,
            backgroundSize: {xl: '550px', lg: '450px', md: '350px', xs: '350px'},
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'bottom -1px left',
        }}/>
    );
}